import { Team, UserProfile } from "types";

import API from "./apiService";

export const getAvailableTeamCoLeaders = async (teamId: Team["id"]): Promise<UserProfile[]> => {
    const result = await API.get(`/CoLeader/${teamId}/getAvailableTeamCoLeaders`);
    return result.data;
}
